export default "__VITE_ASSET__Dz2WdmFA__"